import { patch } from '..';

const unarchiveChatbotSession = async (sessionId: string) => {
  const requestUrl = `chatbot-api/chat-sessions/${sessionId}/unarchive`;
  await patch(requestUrl, null);
};

export default unarchiveChatbotSession;
